<!--
 * @Descripttion: 
 * @Date: 2021-06-04 11:31:31
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-30 17:28:32
 * @Author: Sima thief
-->
<template>
  <div class="page">
    
    <div class="box">
      <div class="item flex-container pd-10" v-for="(item , index) in inWarehouseOrderFeeDTO.goodsDTOList" :key="index">
        <div class="flex-item">
          <div>序号</div>
          <div class="mr-top-20">{{index + 1}}</div>
        </div>
        <div class="flex-item-2">
          <div>运单号</div>
          <div class="mr-top-20">{{item.detailOrderNo}}</div>
        </div>
        <div  class="flex-item-3">
          <el-form
            :model="item"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            
          >
            <el-form-item label="重量（kg）" prop="weight">
              <el-input v-model="item.weight" @change="handler"></el-input>
            </el-form-item>
          
          </el-form>
        </div>
        <div  class="flex-item-3">
          <el-form
            :model="item"
            :rules="rules2"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="体积（CBM）" prop="cbm">
              <el-input v-model="item.cbm" @change="handler"></el-input>
            </el-form-item>
          
          </el-form>
        </div>
          
      </div>
    </div>
    <div class="all mr-top-20">
        总重量 ：{{inWarehouseOrderFeeDTO.allWeight}} (KG) ；总体积：{{inWarehouseOrderFeeDTO.allCbm}}  (CBM)
    </div>


    <div style="width:30%" class="mr-top-80">
         <el-input placeholder="请输入内容" v-model="inWarehouseOrderFeeDTO.transportFee">
    <template slot="prepend">运费小计CNY</template>
  </el-input>
    </div>
  </div>
</template>

  <script>
export default {
  name: "GiowConfirm",
  props: {
    inWarehouseOrderFeeDTO: {
      type: Object,
      default: function () {
        return {};
      },
    },
    orderId:{
       type: String,
    }
  },
  data() {
    return {
    
      rules: {
        weight: [
          { required: true, message: "请输入", trigger: "blur" },
       
         
        ],
    
      },
       rules2: {
        cbm: [
          { required: true, message: "请输入", trigger: "blur" },
       
         
        ],
    
      },
    };
  },
  mounted(){
    console.log('orderId' , this.orderId)
  },

  methods: {
      handler(){
        console.log('inWarehouseOrderFeeDTO' , this.inWarehouseOrderFeeDTO)
        this.calTransportFee()
        
        this.$emit('getinwarehouseorderfeedto', this.inWarehouseOrderFeeDTO);
        
      },
      calTransportFee(){
         this.axios
        .post(`/carrier/order/calTransportFee` , {inWarehouseOrderFeeDTO: this.inWarehouseOrderFeeDTO , orderId: this.orderId})
        .then((res) => {
         
          if(res.data.code === 200){
            console.log('inWarehouseOrderFeeDTOres' , this.inWarehouseOrderFeeDTO)
            this.inWarehouseOrderFeeDTO = res.data.data
            // let {allCbm , allWeight , goodsDTOList , transportFee} = res.data
            
            
            
          }
          
          // const { data } = res.data;
          // this.orderInfor = data;

          // let result = res.data.data
          // console.log('result: ', result)
        });
      }

  }
};
</script>
  
<style lang="scss" scoped>
@import "../styles/index.scss";
.item{
    width: 50%;
        background-color: #f2f2f2;
        margin-bottom: 10px;
}
.item div{
    text-align: center;
}
.flex-item-3 /deep/ .el-form-item__label{
    float: none;
}
.flex-item-3 /deep/ .el-form-item__content{
    left: -50px;
}
.all{
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/mainOrders/components/GiowConfirm.vue